<mat-card>
  <mat-card-actions [align]="align">
    <div fxLayout="5px;">
      <span style="padding-right: 5px;">
        <img alt="logo P8"
             [width]="width()" [height]="height()"
             [ngSrc]="logoImage()"/>
      </span>
      <span style="border-left: 2px solid rgb(154, 154, 154); height: 36px; margin-right: 5px;"></span>
      <span class="mat-title" style="padding-top: 3px;"
      [ngStyle]="{color: color}">{{title}}</span>
    </div>
  </mat-card-actions>
</mat-card>
